import qs from 'query-string';
import { configAxios } from './apiConfig';
import { createLog } from './logService';
import { UPDATE_ACCOMMODATION } from '../store/types/schoolDetailTypes';

export const fetchAccommodations = async (params, dispatch) => {
  try {
    const qsParams = qs.stringify(params);
    const response = await configAxios.get(`/accommodation?${qsParams}`);

    dispatch({
      type: UPDATE_ACCOMMODATION,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
